import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';

@Component({
  selector: 'app-sfa-list-icebox-inspect',
  templateUrl: './sfa-list-icebox-inspect.component.html',
  styleUrls: ['./sfa-list-icebox-inspect.component.scss']
})
export class SfaListIceboxInspectComponent extends GridBaseCase {

  constructor() { super(); }

  ngOnInit() {
  }

}